// initial state
const getDefaults = () => ({
  showAllFields: false,
  showRaw: false,
  uploadsView: null,
  artistArtView: null,
  artistUploadTips: true,
  searchAdvanced: true,
  searchRefresh: null,
  projectRefresh: null,
  dismissed: null,
  cartRefresh: null,
  customSizes: [],
  projectsView: null,          // 'grid' | 'list' | null (null = default grid)
  dsSpreadsheetColumns: null,  // persisted column picker string for DS spreadsheet
  projectsIndexColumns: null,  // persisted column picker string for projects index list
  dsGroupByWorkspace: true,    // group items by workspace in grid/list view
  dsScaleItems: true,          // size grid cards by the item's finished size
  dsShowDeleted: false,        // include soft-deleted design studio items
  dsThumbnailPxDetail: 5,      // px-per-inch for project detail grid
  dsThumbnailPxIndex: 1,       // px-per-inch for project index lanes
  projectInspectorOpen: false,
  projectItemPanelOpen: false,        // project detail summary / bulk editor
  projectBrowseListPanelOpen: false,  // browse index bulk editor
  projectBrowseItemPanelOpen: true,   // browse item editor
  projectBrowseTreeOpen: true,        // browse project tree
  migrationDebugEnabled: false,
  migrationAutoFixEnabled: true,
})

const state = getDefaults()

// getters
const getters = {
  omitFields(state) {
    return state.showAllFields
      ? () => false
      : field => field.read_only
  },
}

// actions
const actions = {
}

// mutations
const mutations = {
  setPreference(state, data) {
    Object.keys(data).forEach(key => {
      state[key] = data[key]
    })
  },
  clear(state) {
    const defaults = getDefaults()
    Object.keys(state).forEach(key => {
      state[key] = defaults[key]
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
